var _ellipse, _path, _mask, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg52(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 109,
    viewBox: "0 0 114 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57,
    cy: 54,
    rx: 46,
    ry: 44,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.466 54.5035C108.466 81.4257 85.5831 103.644 56.8603 103.644C28.1376 103.644 5.255 81.4257 5.255 54.5035C5.255 27.5812 28.1376 5.3634 56.8603 5.3634C85.5831 5.3634 108.466 27.5812 108.466 54.5035Z",
    stroke: "#F2F5FA",
    strokeWidth: 10.51
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_538_285",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1328 6.11803C48.636 3.12244 50.6867 0.273383 53.7182 0.0985616C59.8868 -0.257176 66.0875 0.350822 72.0741 1.90978C79.8411 3.93236 87.0707 7.50953 93.2847 12.4047C99.4986 17.2998 104.555 23.4013 108.12 30.3056C111.685 37.2099 113.677 44.7596 113.964 52.4554C114.251 60.1511 112.827 67.8174 109.785 74.9472C106.744 82.077 102.155 88.5078 96.3212 93.8142C90.4878 99.1206 83.5431 103.182 75.9466 105.729C70.0786 107.696 63.9251 108.726 57.7321 108.787C54.711 108.817 52.4758 106.138 52.747 103.129V103.129C53.0154 100.152 55.6397 97.9814 58.6273 97.8879C63.2387 97.7435 67.8112 96.9285 72.1852 95.4619C78.2624 93.4243 83.8182 90.1755 88.4849 85.9304C93.1516 81.6853 96.823 76.5406 99.2561 70.8368C101.689 65.1329 102.829 58.9999 102.599 52.8433C102.369 46.6867 100.776 40.647 97.924 35.1235C95.0721 29.6001 91.0268 24.7189 86.0557 20.8027C81.0845 16.8866 75.3009 14.0249 69.0872 12.4068C64.6063 11.24 59.9755 10.7391 55.356 10.9125C52.3799 11.0242 49.6201 9.05605 49.1328 6.11803V6.11803Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1328 6.11803C48.636 3.12244 50.6867 0.273383 53.7182 0.0985616C59.8868 -0.257176 66.0875 0.350822 72.0741 1.90978C79.8411 3.93236 87.0707 7.50953 93.2847 12.4047C99.4986 17.2998 104.555 23.4013 108.12 30.3056C111.685 37.2099 113.677 44.7596 113.964 52.4554C114.251 60.1511 112.827 67.8174 109.785 74.9472C106.744 82.077 102.155 88.5078 96.3212 93.8142C90.4878 99.1206 83.5431 103.182 75.9466 105.729C70.0786 107.696 63.9251 108.726 57.7321 108.787C54.711 108.817 52.4758 106.138 52.747 103.129V103.129C53.0154 100.152 55.6397 97.9814 58.6273 97.8879C63.2387 97.7435 67.8112 96.9285 72.1852 95.4619C78.2624 93.4243 83.8182 90.1755 88.4849 85.9304C93.1516 81.6853 96.823 76.5406 99.2561 70.8368C101.689 65.1329 102.829 58.9999 102.599 52.8433C102.369 46.6867 100.776 40.647 97.924 35.1235C95.0721 29.6001 91.0268 24.7189 86.0557 20.8027C81.0845 16.8866 75.3009 14.0249 69.0872 12.4068C64.6063 11.24 59.9755 10.7391 55.356 10.9125C52.3799 11.0242 49.6201 9.05605 49.1328 6.11803V6.11803Z",
    fill: "url(#paint0_linear_538_285)",
    stroke: "url(#paint1_linear_538_285)",
    strokeWidth: 11.0262,
    mask: "url(#path-3-inside-1_538_285)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.457 48.8001H52.661V52.1211H43.913V56.7381C44.642 55.8471 46.127 55.1451 47.774 55.1451C52.364 55.1451 53.93 58.6011 53.93 61.6521C53.93 65.6751 51.608 68.5371 47.126 68.5371C42.887 68.5371 40.457 66.1881 40.133 62.9751H43.805C44.129 64.3521 45.236 65.3511 47.072 65.3511C49.286 65.3511 50.285 63.7851 50.285 61.7061C50.285 59.4921 49.178 58.2771 47.045 58.2771C45.479 58.2771 44.48 59.1411 44.075 60.3561H40.457V48.8001ZM56.591 68.2671V65.4591C61.046 61.6791 65.717 58.1961 65.717 54.5781C65.717 52.8231 64.934 51.6351 63.071 51.6351C61.262 51.6351 60.263 52.9311 60.236 55.0101H56.564C56.699 50.5011 59.588 48.4221 63.125 48.4221C67.364 48.4221 69.497 50.9331 69.497 54.3621C69.497 58.9251 65.096 62.4891 61.964 65.1351H69.929V68.2671H56.591Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_538_285",
    x1: 57.1397,
    y1: 0,
    x2: 57.1397,
    y2: 108.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAF3AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8C3C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_538_285",
    x1: 57.1397,
    y1: 0,
    x2: 57.1397,
    y2: 108.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAF3AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8C3C6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg52);
export default __webpack_public_path__ + "static/media/52.88ed60d76b2b788afbf2ad912f481bd6.svg";
export { ForwardRef as ReactComponent };